import { getData as apiGetData } from 'api/Api'
import {
  addCardFronts,
  add as addCard
} from '../redux/cards'

type Payload = {
  cardIds: number[];
}
  
const fetchCardFronts = (payload: Payload) => async dispatch => { 
  const { cardIds } = payload

  const { Cards } = await apiGetData('CardFronts', {
    ids: cardIds,
  })

  const cardFronts: any[] = []
  const noAccessCards: number[] = []

  cardIds.forEach((cardId, index) => {
    const Card = Cards.find(Card => Card.Id === cardId)

    if (Card) {
      cardFronts.push(Card)
    } else {
      noAccessCards.push(cardId)
    }
  })

  const actions: any[] = []

  if (cardFronts.length) {
    actions.push(addCardFronts(cardFronts))
  }

  for (const cardId of noAccessCards) {
    actions.push(addCard({
      id: cardId,
      noAccess: true,
    }))
  }

  if (actions.length) {
    dispatch(actions)
  }
}

export default fetchCardFronts
